import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {LexemeUtilities} from './../../lexeme/page/editor/LexemeHelper';
import {SearchResult} from '../SearchResult';
import {SearchResultButtonBar} from './../SearchResultButtonBar';
import {AdministrationUtilities} from './../../administration/AdministrationHelper';
import {SCModalTopSpinner} from '../../dict-components/spinner/SCModalTopSpinner/SCModalTopSpinner';

import stylesSearchPage from '../../_css/dictionary/searchPage.module.css';
import {userService} from "../../_redux/authentication/services/user.services";

const initialState = {
    searchParams: {},
    isLoading: false
};

export function getInitialState() {
    return initialState;
}

export function buildEntrySearchByForm(form, langId, host, className, includeAlternativeForms) {
    var forms = [];
    forms.push(form);
    className = typeof className === 'undefined' ? 'Entry' : className;
    var operator = "OR";
    var specialChars = false;
    var nPage = 1;
    return search(forms, operator, className, specialChars, nPage, langId, host, 'STARTS_WITH', includeAlternativeForms);
}

function search(forms, operator, className, specialChars, nPage, langId, host, type, includeAlternativeForms) {
    var searchParams = {
        forms, operator, className, specialChars, nPage, langId, type, includeAlternativeForms
    };

    setUser(searchParams);

    return Dict.call('service/search/' + LexemeUtilities.encodeUrl(JSON.stringify(searchParams)) + '/', undefined, host);
}

function setUser(searchParams) {
    searchParams.user = { usr: localStorage.user, roles: localStorage.userRoles, su: localStorage.su};
}

export function searchByParams(searchParams) {
    setUser(searchParams);
    return Dict.call('service/search/' + LexemeUtilities.encodeUrl(JSON.stringify(searchParams)) + '/');
}

export function performSearchByInitialState() {
    var searchParams = getInitialState().searchParams;
    if (Object.keys(searchParams).length > 0) {
        var service = searchParams.forms.length === 1 && typeof searchParams.forms[0].id !== 'undefined' ? 'service/searchById/' + searchParams.forms[0].id + '/' + searchParams.className + '/' : 'service/search/' + LexemeUtilities.encodeUrl(JSON.stringify(searchParams)) + '/'

        Dict.call(service).then(result => {
            const SearcResultConst = <SearchResult nPage={searchParams.nPage} result={result}
                                                   language={AdministrationUtilities.getLangItemById(searchParams.langId)}/>;
            ReactDOM.render(SearcResultConst, document.getElementById("dict-result-container"));
        });
    }
}

export function performSearch(searchParams, isById, callback) {
    if (typeof searchParams.forms === "undefined") {
        initialState.searchParams.nPage = searchParams.nPage;
    } else {
        initialState.searchParams = searchParams;
    }

    setUser(initialState.searchParams);

    initialState.isLoading = true;
    var searchString =  LexemeUtilities.encodeUrl(JSON.stringify(initialState.searchParams));
    var callSearch = typeof isById !== 'undefined' && isById ? 'service/searchById/' + initialState.searchParams.forms[0].id + '/' + initialState.searchParams.className + '/' : 'service/search/' + searchString + "/";
    return Dict.call(callSearch).then(result => {
        if(isById) {
            result.items[0].fields.entryForm = searchParams.forms[0].label;
            var abstr = searchParams.forms[0].abstr;
            result.items[0].fields.abstr = typeof abstr !== 'undefined' ? searchParams.forms[0].abstr.replace('<hightlight-search-result>', '').replace('</hightlight-search-result>') : '';
            result.items[0].fields.polyId = searchParams.forms[0].polyId;
            result.items[0].fields.senseId = searchParams.forms[0].senseId;
        }
        const SearcResultConst = <SearchResult searchParams={searchParams} nPage={searchParams.nPage} result={result}
                                               language={AdministrationUtilities.getLangItemById(searchParams.langId)}/>;

        const SearchResultButtonBarConst = <SearchResultButtonBar/>;

        setTimeout(function () {
            ReactDOM.render(SearcResultConst, document.getElementById("dict-result-container"));
            ReactDOM.render(SearchResultButtonBarConst, document.getElementById("dict-result-container-buttonbar"));
            /*ReactDOM.render(<SCModalTopSpinner show={false}
                                               msg={''}/>, document.getElementById("dict-modal-container"));*/

            var dicResultContent = document.getElementById("dict-result-content");
            if (result.items.length > 0 && !dicResultContent.classList.contains(stylesSearchPage['dict-result-content--active']))
                dicResultContent.classList.add(stylesSearchPage['dict-result-content--active']);

            setTimeout(function () {
                if (!isById)
                    document.getElementById("dict-result-list").click();
                initialState.isLoading = false;
                if(typeof callback === 'function')
                    callback();
            }, 100); // per far comparire/scomparire la scrollbar
        }, 10);
    });
}
